import { Injectable, inject } from "@angular/core";
import { AiPromptType } from "../../enums/AiPromptType";
import { BaseService } from "../base.service";
import { HttpRestService } from "../http-client/http-rest-client.service";

@Injectable()
export class AiPromptApiService extends BaseService {
    private restService = inject(HttpRestService);


    public getPrompt(promptType: AiPromptType): Promise<string> {
        return this.handleResponse(this.restService.get({
            url: `/ai-prompt/${promptType}`
        }));
    }

    public updatePrompt(promptType: AiPromptType, prompt: string): Promise<boolean> {
        return this.handleResponse(this.restService.post({
            url: `/ai-prompt/${promptType}`,
            data: { Prompt: prompt }
        }));
    }

    public getAvatarGenerationRequiredPlaceholders(): Promise<string[]> {
        return this.handleResponse(this.restService.get({
            url: `/ai-prompt/avatar-generation/required-placeholders`
        }));
    }

    public getLocationLeverageRequiredPlaceholders(): Promise<string[]> {
        return this.handleResponse(this.restService.get({
            url: `/ai-prompt/location-leverage/required-placeholders`
        }));
    }

    public getPromptBaseMassAiAvatarPromptGeneratorScaffold(): Promise<{ prefix: string; suffix: string }> {
        return this.handleResponse(this.restService.get({
            url: `/ai-prompt/prompt-base-mass-ai-avatar-prompt-generator/scaffold`
        }));
    }

    public batchUpdatePrompts(prompts: Record<number, string>): Promise<boolean> {
        return this.handleResponse(this.restService.post({
            url: `/ai-prompt/batch`,
            data: { Prompts: prompts }
        }));
    }
}
